import React, { useEffect, useState } from 'react';
import { CFCProps } from 'types';
import { connect, useDispatch } from 'react-redux';
import {
  ComposedModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Checkbox,
  Button
} from 'carbon-components-react';
import {
  hideAnnouncementBulkStart,
  removeAnnouncement
} from 'redux/announcement';

const MemberAnnouncement: React.FC<Props> = ({
  onModalClose,
  isModalOpen,
  announcements,
  referralsIds
}) => {
  const dispatch = useDispatch();
  const disableHideAnnouncement = true;
  const [filteredAnnouncements, setFilteredAnnouncements] = useState<
    Array<any>
  >([]);
  const [dontShowAgainId, setDontShowAgainId] = useState<Array<number>>([]);
  const [isHidingAnnouncement, setIsHidingAnnouncement] = useState<boolean>(
    false
  );

  const handleCheckboxChange = (checked: boolean) => {
    if (checked) {
      const noticesId: Array<number> = filteredAnnouncements?.map(
        (ann) => ann.id
      );
      setDontShowAgainId(noticesId);
    } else {
      setDontShowAgainId([]);
    }
  };

  const handleDontShowAgainSubmit = () => {
    if (dontShowAgainId.length > 0) {
      setIsHidingAnnouncement(true);
      dispatch(hideAnnouncementBulkStart(dontShowAgainId));
      dontShowAgainId.forEach((noticeId) => {
        dispatch(removeAnnouncement(noticeId));
      });
      setTimeout(() => {
        setIsHidingAnnouncement(false);
        onModalClose();
      }, 700);
    } else {
      setIsHidingAnnouncement(false);
      onModalClose();
    }
  };

  useEffect(() => {
    if (announcements?.length > 0) {
      const announcementData: Array<any> = [];
      announcements.forEach((ele: any) => {
        let orgName = '';
        const orgArray = ele.Organisations;
        referralsIds.forEach((refId: any) => {
          orgArray?.forEach((org: any) => {
            if (refId === org.id) {
              orgName = org.name;
              const data = {
                orgName: orgName,
                title: ele.title,
                text: ele.text,
                id: ele.id
              };
              announcementData.push(data);
            }
          });
        });
      });
      setFilteredAnnouncements(announcementData);
    }
  }, [announcements, referralsIds]);

  return (
    <>
      {filteredAnnouncements && filteredAnnouncements.length > 0 && (
        <ComposedModal
          className="member-announcement-modal"
          data-testid="memberAnnouncementModal"
          open={isModalOpen}
          preventCloseOnClickOutside={true}
          onClose={() => onModalClose()}
        >
          <ModalHeader>
            <div className="member-announcement-modal-header">
              MEMBER ANNOUNCEMENTS
            </div>
          </ModalHeader>
          <ModalBody>
            {filteredAnnouncements.map((notice: any, inx: number) => {
              return (
                <div
                  key={inx}
                  className={`${
                    inx !== filteredAnnouncements.length - 1
                      ? 'member-announcement-modal-items'
                      : ''
                  }`}
                >
                  <div className="member-announcement-modal-content">
                    <div className="member-announcement-modal-title">
                      <div>
                        {notice.orgName}
                        &nbsp;-&nbsp;
                        {notice.title}
                      </div>
                    </div>
                    <div
                      className="member-announcement-modal-body text"
                      dangerouslySetInnerHTML={{ __html: notice.text }}
                    />
                  </div>
                </div>
              );
            })}
          </ModalBody>
          <ModalFooter>
            <div className="member-announcement-modal-action-buttons">
              {filteredAnnouncements.length > 1 && !disableHideAnnouncement && (
                <Checkbox
                  defaultChecked={false}
                  labelText={`Don't show again`}
                  id={'dontShowAgainCheckbox'}
                  key={`file-${filteredAnnouncements[0].id}`}
                  onChange={(checked: boolean) => handleCheckboxChange(checked)}
                />
              )}
            </div>
            <div className="member-announcement-modal-action-buttons">
              <Button
                data-testid="applyChanges"
                onClick={handleDontShowAgainSubmit}
                disabled={isHidingAnnouncement}
              >
                OK
              </Button>
            </div>
          </ModalFooter>
        </ComposedModal>
      )}
    </>
  );
};

const connector = connect();

type OwnProps = {
  onModalClose: Function;
  isModalOpen: boolean;
  announcements: any;
  referralsIds: Array<Number>;
};

type Props = CFCProps<typeof connector> & OwnProps;

MemberAnnouncement.displayName = 'MemberAnnouncement';

export default React.memo(connector(MemberAnnouncement));
